export default __webpack_public_path__ + "statics/images/automaticRightsEmpty.1738095297605.svg";